'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { track } from '@/lib/analytics/ym';
import { SITE } from '@/lib/site-config';
import { FadeUp } from '@/components/motion';
import { FAQ_IDS } from '@/lib/faq-ids';

// Разметка ответов живёт в словаре как теги — перевод правит текст, не JSX.
const richTags = {
  brand: SITE.brand,
  p: (chunks: ReactNode) => <p className="mt-3 first:mt-0">{chunks}</p>,
  b: (chunks: ReactNode) => <span className="font-semibold">{chunks}</span>,
  em: (chunks: ReactNode) => <em>{chunks}</em>,
  ul: (chunks: ReactNode) => (
    <ul className="mt-2 space-y-2 list-disc list-inside">{chunks}</ul>
  ),
  li: (chunks: ReactNode) => <li>{chunks}</li>,
};

export function FAQ() {
  const t = useTranslations('FAQ');

  return (
    <section id="faq" className="bg-muted/40">
      <div className="container mx-auto max-w-4xl px-4 md:px-6 lg:px-8 py-24 md:py-32">
        <FadeUp>
          <p className="text-xs uppercase tracking-wider text-muted-foreground">
            {t('eyebrow')}
          </p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight">
            {t('heading')}
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <Accordion className="mt-8">
            {FAQ_IDS.map((id) => (
              <AccordionItem key={id} value={id}>
                <AccordionTrigger
                  className="py-4 text-base md:text-lg"
                  onClick={() => track.faqOpen(id)}
                >
                  {t(`items.${id}.q`)}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-muted-foreground">
                  {t.rich(`items.${id}.a`, richTags)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
